const entity = 'breeds'
const entitySingle = 'breed'
const tableIcon = 'cil-paw'

export {
  entity,
  entitySingle,
  tableIcon
}
